import Vue from 'vue'
import Router from 'vue-router'
import decode from 'jwt-decode'
import store from '../store'
import PRM from '../core/PermissionConstants'
import routes from "@/app/router/index";

Vue.use(Router)

let routesVue = [

  // * LOGIN
  {
    path: '/',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },

  // * DASHBOARD ESTANDAR VIEW
  // {
  //   path: '/dashboard',
  //   name: 'Dashboard',
  //   component: () => import('../views/Dashboard.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // * RECEPTION
  {
    path: '/recepcion',
    name: 'Recepcion',
    component: () => import('../views/Recepcion.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_RECEPTION,
      pm: true
    }
  },
  {
    path: '/recepcion/addendum',
    name: 'Addendum',
    component: () => import('../views/Addendum/Addendum.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.LIST_ADDENDUM
    }
  },
  {
    path: '/recepcion/editarPaciente',
    name: 'EditarPaciente',
    props: true,
    component: () => import('../views/EditarPaciente.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.UPDATE_PATIENT
    }
  },
  {
    path: '/recepcion/registrarPaciente',
    name: 'RegistrarPaciente',
    component: () => import('../views/RegistrarPaciente.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.ADD_PATIENT
    }
  },

  // * SOMATOMETRY
  {
    path: '/somatometria',
    name: 'Somatometria',
    component: () => import('../views/somatometry/Somatometry.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_DIARY,
      pm: true
    }
  },

  // * Calendar
  {
    path: '/agenda/nuevaCita',
    name: 'CrearCita',
    component: () => import('../views/CrearCita.vue'),
    meta: {
      requireAuth: true
    }
  },
  // {
  //   path: '/agenda/reprogramarCita',
  //   name: 'ReprogramarCita',
  //   component: () => import('../views/ReprogramarCita.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/agenda',
  //   name: 'Agenda',
  //   component: () => import('../views/Schedule/Schedule.vue'),
  //   // component: () => import('../views/Agenda.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/agenda/modificarCita',
  //   name: 'EditarCita',
  //   component: () => import('../views/ModificarCita.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // * EXTERNAL CONSULTING
  // {
  //   path: '/consultas',
  //   name: 'Consultas',
  //   component: () => import('../views/Consultation/ConsultationSubMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  {
    path: '/consultas/pendientes',
    name: 'ConsultasPendientes',
    component: () => import('../views/Consultation/Consultas.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CONSULTATION_PENDING,
      pm: true
    }
  },
  {
    path: '/consultas/historial',
    name: 'HistorialConsultas',
    component: () => import('../views/Consultation/Consultashistorial.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CONSULTATION_HISTORY
    }
  },
  // {
  //   path: '/consultas/detalle',
  //   name: 'DetalleConsulta',
  //   component: () => import('../views/Consultation/ConsultaDetalle.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/consultas/interrogatorio',
  //   name: 'Interrogatorio',
  //   component: () => import('../views/Consultation/Interrogatorio.vue'),
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_VITAL_SIGNS
  //   }
  // },
  // {
  //   path: '/consultas/atender',
  //   name: 'AtenderConsulta',
  //   props: true,
  //   component: () => import('../views/Consultation/AtenderConsulta.vue'),
  //   meta: {
  //     requireAuth: true
  //   }

  // },
  // {
  //   path: '/consultas/modificar',
  //   name: 'EditarConsulta',
  //   props: true,
  //   component: () => import('../views/Consultation/UpdateConsultation.vue'),
  //   meta: {
  //     requireAuth: true
  //   }

  // },


  // * DENTAL CONSULTING
  // {
  //   path: '/dental/consulta',
  //   name: 'ConsultaDental',
  //   props: true,
  //   component: () => import('../views/Dental/Consultation.vue'),
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_DENTAL,
  //   }
  // },
  // {
  //   path: '/dental/pendientes',
  //   name: 'ConsultaDentalPendientes',
  //   props: true,
  //   component: () => import('../views/Dental/Pending.vue'),
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_DENTAL_BEGIN,
  //     pm: true
  //   }
  // },
  // {
  //   path: '/dental/historial',
  //   name: 'ConsultaDentalHistorial',
  //   props: true,
  //   component: () => import('../views/Dental/History.vue'),
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_DENTAL_HISTORY,
  //   }
  // },
  // {
  //   path: '/dental/modificar',
  //   name: 'EditarConsultaDental',
  //   props: true,
  //   component: () => import('../views/Dental/Update.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // * PHARMACY
  // {
  //   path: '/farmacia',
  //   name: 'Farmacia',
  //   component: () => import('../views/Pharmacy/PharmacySubMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/farmacia/dispensar',
  //   name: 'Dispensar',
  //   component: () => import('../views/Pharmacy/DispensePrescription.vue'),
  //   meta: {
  //     requireAuth: true

  //   }
  // },
  {
    path: '/farmacia/pendientes',
    name: 'FarmaciaPendientes',
    component: () => import('../views/Pharmacy/Farmaciapendientes.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_PHARMACY_PENDING,
      pm: true
    }
  },
  // {
  //   path: '/farmacia/detalle',
  //   name: 'FarmaciaDetalle',
  //   component: () => import('../views/Pharmacy/PrescriptionDetails.vue'),
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_PHARMACY_HISTORY
  //   }
  // },
  {
    path: '/farmacia/historial',
    name: 'FarmaciaHistorial',
    component: () => import('../views/Pharmacy/Farmaciahistorial.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_PHARMACY_HISTORY
    }
  },
  {
    path: '/farmacia/almacen',
    name: 'FarmaciaAlmacen',
    component: () => import('../views/Pharmacy/Stock.vue'),
    meta: {
      requireAuth: true,
    }
  },
  {
    path: '/farmacia/merma',
    name: 'Merma',
    component: () => import('../views/Pharmacy/WarehouseOutput.vue'),
    meta: {
      requireAuth: true,
    }
  },

  // * LABORATORY

  // {
  //   path: '/laboratorio/estudio',
  //   name: 'LaboratoryMenuView',
  //   component: () => import('../views/laboratory/LaboratoryMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/laboratorio/estudio/menu',
  //   name: 'StudySubMenuView2',
  //   component: () => import('../views/laboratory/LaboratorySubMenuView.vue'),
  //   props: true,
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/laboratorio/proceso',
  //   name: 'EstudioProceso2',
  //   component: () => import('../views/StudyProcess.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  {
    path: '/laboratorio/historial',
    name: 'HistorialEstudio2',
    component: () => import('../views/StudyHistory.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_LABORATORY_HISTORY
    }
  },
  // {
  //   path: '/laboratorio/estudio/detalle',
  //   name: 'DetalleEstudio2',
  //   component: () => import('../views/StudyDetail.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/laboratorio',
  //   name: 'LabMenuView',
  //   component: () => import('../views/study/ImageMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  {
    path: '/laboratorio/validar',
    name: 'CerrarEstudio2',
    component: () => import('../views/Estudiocerrar.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_LABORATORY_END
    }
  },
  {
    path: '/laboratorio/resultados',
    name: 'ResultadosLaboratorio',
    component: () => import('../views/laboratory/LaboratoryResultsView.vue'),
    props: true,
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_LABORATORY_END
    }
  },
  {
    path: '/laboratorio/detalle/resultados',
    name: 'ResultadosLaboratorio2',
    component: () => import('../views/laboratory/LaboratoryResultsView.vue'),
    props: true,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/laboratorio/comenzar',
    name: 'IniciarEstudio2',
    component: () => import('../views/Estudio.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_LABORATORY_BEGIN,
      pm: true
    }
  },
  // {
  //   path: '/laboratorio/detallesConsulta',
  //   name: 'DetallesConsultaLaboratorio',
  //   component: () => import('../views/laboratory/LaboratoryInformationConsultation.vue'),
  //   props: true,
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_LABORATORY_BEGIN,
  //     pm: true
  //   }
  // },
  // {
  //   path: '/laboratorio/interpretacion',
  //   name: 'InterpretationMenuView2',
  //   component: () => import('../views/interpretation/InterpretationMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/laboratorio/interpretacion/menu',
  //   name: 'InterpretationSubMenuView2',
  //   component: () => import('../views/interpretation/InterpretationSubMenuView.vue'),
  //   props: true,
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // * IMAGE
  {
    path: '/imagen/comenzar',
    name: 'IniciarEstudio1',
    component: () => import('../views/Estudio.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_IMAGE_END,
      pm: true
    }
  },
  // {
  //   path: '/imagen/estudio',
  //   name: 'StudyMenuView1',
  //   component: () => import('../views/study/StudyMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/imagen/estudio/menu',
  //   name: 'StudySubMenuView1',
  //   component: () => import('../views/study/StudySubMenuView.vue'),
  //   props: true,
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/imagen/proceso',
  //   name: 'EstudioProceso1',
  //   component: () => import('../views/StudyProcess.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  {
    path: '/imagen/historial',
    name: 'HistorialEstudio1',
    component: () => import('../views/StudyHistory.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_IMAGE_HISTORY
    }
  },
  {
    path: '/imagen/estudio/detalle',
    name: 'DetalleEstudio1',
    component: () => import('../views/StudyDetail.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/imagen/estudio/editar',
    name: 'EditarEstudio',
    component: () => import('../views/papanicolauHistory/papanicolauHistoryEdit.vue'),
    meta: {
      requireAuth: true,
      isReadOnly: false
    }
  },
  {
    path: '/imagen/estudio/informacion',
    name: 'InformacionEstudio',
    component: () => import('../views/papanicolauHistory/papanicolauHistoryEdit.vue'),
    meta: {
      requireAuth: true,
      isReadOnly: true
    }
  },
  // {
  //   path: '/dashboard/estudio',
  //   name: 'EstudioDashboard',
  //   component: () => import('../views/studyPending/StudyPendingView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/imagen',
  //   name: 'ImageMenuView',
  //   component: () => import('../views/study/ImageMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  {
    path: '/imagen/cerrar',
    name: 'CerrarEstudio1',
    component: () => import('../views/Estudiocerrar.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_IMAGE_END
    }
  },
  // {
  //   path: '/imagen/interpretacion',
  //   name: 'InterpretationMenuView1',
  //   component: () => import('../views/interpretation/InterpretationMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/imagen/interpretacion/menu',
  //   name: 'InterpretationSubMenuView1',
  //   component: () => import('../views/interpretation/InterpretationSubMenuView.vue'),
  //   props: true,
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // * INTERPRETATION
  // {
  //   path: '/imagen/interpretacion/historial',
  //   name: 'InterpretacionHistorial1',
  //   component: () => import('../views/Interpretacionhistorial.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/imagen/interpretacion/nueva',
  //   name: 'InterpretacionNueva1',
  //   component: () => import('../views/NuevaInterpretacion.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // * MEDICAL RECORD
  {
    path: '/historialClinico',
    name: 'HistoriaClinica',
    component: () => import('../views/MedicalRecord/MedicalRecord.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CLINIC_HISTORY,
      pm: true
    }
  },
  // {
  //   path: '/historialClinico/Detalles',
  //   name: 'HistorialClinico',
  //   component: () => import('../views/MedicalRecord/Details.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // * USERS
  {
    path: '/usuarios',
    name: 'Usuarios',
    component: () => import('../views/Usuarios.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_USER,
      pm: true
    }
  },
  {
    path: '/usuarios/nuevoUsuario',
    name: 'UsuarioNuevo',
    component: () => import('../views/user/AddUser.vue'),
    meta: {
      requireAuth: true
    }
  },
  // {
  //   path: '/usuarios/editarUsuario',
  //   name: 'EditarUsuario',
  //   component: () => import('../views/user/UpdateUser.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  // {
  //   path: '/usuarios/informacionUsuario',
  //   name: 'InformacionUsuario',
  //   component: () => import('../views/user/InformationUser.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },

  // * LOCATION
  {
    path: '/localidad',
    name: 'Localidad',
    component: () => import('../views/location/LocationView.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.LOCALITY,
      pm: true
    }
  },

  // * REPORTS
  // {
  //   path: '/reportes',
  //   name: 'Reportes',
  //   component: () => import('../views/Reports/ReportsMenu.vue'),
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_REPORTS
  //   }
  // },
  {
    path: '/reportes/reportadosDescartados',
    name: 'EstudiosReportadosDescartados',
    component: () => import('../views/Reports/reportedAndDiscarded.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_REPORTS_DISCARTED,
      pm: true
    }
  },
  {
    path: '/reportes/interpretes',
    name: 'Interpretes',
    component: () => import('../views/Reports/Interpretations.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_REPORTS_INTERPRETERS
    }
  },
  {
    path: '/reportes/productividad',
    name: 'Productividad',
    component: () => import('../views/Reports/ProductivityView.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/reportes/descarga/estudios',
    name: 'DescargaEstudios',
    component: () => import('../views/Reports/DownloadStudies.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_DOWNLOAD_STUDIES
    }
  },

  // * CONFIGURATION
  {
    path: '/configuracion/preferencias',
    name: 'PACSConfiguration',
    component: () => import('../views/servers/ConfigurationView.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_PACS,
      pm: true
    }
  },
  {
    path: '/configuracion/roles-permisos',
    name: 'RolesPermisos',
    component: () => import('../views/RolePermission/RolePermissions.vue'),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/configuracion/roles',
    name: 'Roles',
    component: () => import('../views/RolePermission/Roles.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_ROLES
    }
  },
  // {
  //   path: '/configuracion/modulos',
  //   name: 'Modulos',
  //   component: () => import('../views/module/ModuleView.vue'),
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_ROLES
  //   }
  // },
  {
    path: '/configuracion/agregar/rol',
    name: 'AgregarRol',
    component: () => import('../views/RolePermission/AddRole.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_ROLES
    }
  },

  {
    path: '/configuracion/sucursales',
    name: 'Sucursales',
    component: () => import('../views/BranchOffice/BranchOffices.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_BRANCH_OFFICE
    }
  },
  {
    path: '/configuracion/especialidades',
    name: 'Especialidades',
    component: () => import('../views/Speciality/Speciality.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_SPECIALITY
    }
  },
  {
    path: '/configuracion/modalidades',
    name: 'Modalidades',
    component: () => import('../views/Modality/Modality.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_MODALITY
    }
  },
  {
    path: '/configuracion/perfiles',
    name: 'Perfiles Estudio',
    component: () => import('../views/studyModality/StudyModality.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_STUDY_PROFILE
    }
  },
  // {
  //   path: '/configuracion/consultorios',
  //   name: 'Consultorios',
  //   component: () => import('../views/ConsultingRoom/ConsultingRoom.vue'),
  //   meta: {
  //     requireAuth: true,
  //     prm: PRM.MODULE_CONSULTING_ROOM
  //   }
  // },
  {
    path: '/configuracion/antecedentes',
    name: 'Antecedentes',
    component: () => import('../views/Antecedent/Antecedent.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_BACKGROUND
    }
  },
  {
    path: '/configuracion/TipoPersonal',
    name: 'Tipo de personal',
    component: () => import('../views/TypePersonal/TypePersonal.vue'),
    meta: {
      requireAuth: true,
      // prm: PRM.MODULE_TYPE_PERSONAL

    }
  },
  // {
  //   path: '/configuracion/responsables',
  //   name: 'Responsables',
  //   component: () => import("@/views/Responsible/Responsibles.vue"),
  //   meta: {
  //     requireAuth: false,
  //     // prm: PRM.MODULE_PERMISSIONS
  //   }
  // },
  {
    path: "/perfil",
    name: "perfil",
    component: () => import("@/views/profile/ProfileView.vue"),
    meta: {
      requireAuth: true
    }
  },


  // * ERROR PAGES
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue'),
  },
  {
    path: "/sinPermiso",
    name: "sinPermiso",
    component: () => import("@/views/415.vue")
  },
  {
    path: "/sinAutorizacion",
    name: "sinAutorizacion",
    component: () => import("@/views/401.vue")
  },
  {
    path: "/ventanaDuplicada",
    name: "ventanaDuplicada",
    component: () => import("@/views/duplicateWindow.vue"),
    meta: {
      requireAuth: false
    }
  },
  {
    path: "/informacionConsulta/:id",
    name: "informacionConsulta",
    component: () => import("../views/QRScanViews/PrescriptionInfo.vue")
  },
  {
    path: "*",
    component: () => import("@/views/404.vue")
  },
  {
    path: '/configuracion/laboratorio/categorias',
    name: 'Categorias',
    component: () => import('../views/Category/Category.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CONF
    }
  },
  {
    path: '/configuracion/laboratorio/parametros',
    name: 'Parametros',
    component: () => import('../views/Parameter/Parameter.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CONF
    }
  },
  {
    path: '/configuracion/permisos',
    name: 'Permisos',
    component: () => import('../views/RolePermission/Permissions.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CONF
    }
  },
  // {
  //   path: '/dental',
  //   name: 'DentalMenuView',
  //   component: () => import('../views/Dental/DentalMenuView.vue'),
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  {
    path: '/configuracion/dental/procedimientos',
    name: 'Procedimientos',
    component: () => import('../views/Procedure/Procedure.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CONF
    }
  },
  {
    path: '/configuracion/signos_vitales',
    name: 'SignosVitales',
    component: () => import('../views/VitalSignType/VitalSignType.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CONF
    }
  },
  {
    path: '/configuracion/logos',
    name: 'Logos',
    component: () => import('../views/logos/Logos.vue'),
    meta: {
      requireAuth: true,
      prm: PRM.MODULE_CONF
    }
  }
  /*,
      {
        path:'/configuracion/sincronizacion',
        name:'Sincronizacion',
        component:()=> import('../views/Synchronization/SynchronizationView.vue'),
        meta: {
          requireAuth: true,
          prm: PRM.MODULE_CONF
        }
      }*/
];

// console.log(routes);
// routesVue = routesVue.push.apply(routesVue, routes);
routesVue.push.apply(routesVue, routes);


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // base: '/',
  routes: routesVue
})
// perfil
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token');
  let withToken = token ? true : false;
  const protectedRoute = to.matched.some(record => record.meta.requireAuth);

  if (protectedRoute || (to.name == 'login' || to.name == '404')) {

    if (!withToken && to.name == 'login') {
      next();
    } else if (!withToken && to.name != 'login') {
      next({
        name: 'login'
      });
    } else if (withToken && to.name == 'login') {
      const token_decode = JSON.parse(localStorage.getItem("preferencias"));
      if (token_decode.view_type) {
        next({
          name: 'Dashboard'
        })
      } else {
        let routes = router.options.routes;
        let newRoutes = [];
        for (let i = 0; i < routes.length; i++) {
          const route = routes[i];

          if (
            (new Vue).$utilFront.nonEmpty(route) &&
            (new Vue).$utilFront.nonEmpty(route.meta) &&
            (new Vue).$utilFront.nonEmpty(route.meta.requireAuth) &&
            (new Vue).$utilFront.nonEmpty(route.meta.prm)
          ) {
            if (
              (route.meta.requireAuth === true && !route.meta.prm == "") ||
              !route.meta.prm == "undefined"
            ) {
              if (
                (new Vue).$utilFront.withPermission(route.meta.prm) &&
                route.meta.pm == true
              ) {
                newRoutes.push(route);
              }
            }
          }
        }
        const newRoute = newRoutes.slice(0, 1).shift();
        next({
          name: newRoute.name
        });
      }
    } else {
      let prm = to.meta.prm || "ND";
      if (prm == "ND") {
        next();
      } else {
        if ((new Vue).$utilFront.withPermission(prm)) {
          next();
        } else {
          next({
            name: 'sinPermiso'
          });
        }
      }
    }
  } else if (to.name == 'sinAutorizacion') {
    localStorage.clear();
    next({
      name: 'login'
    });
  } else {
    next();
  }


  // const protectedRoute = to.matched.some(record => record.meta.requireAuth);

  // if (protectedRoute || (to.name == 'login' || to.name == '404')) {

  //   if (!withToken && to.name == 'login') {
  //     next();
  //   } else if (!withToken && to.name != 'login') {
  //     next({
  //       name: 'login'
  //     });
  //   } else if (withToken && to.name == 'login') {
  //     const token_decode = JSON.parse(localStorage.getItem("preferencias"));
  //     if (token_decode.view_type) {
  //       next({
  //         name: 'Dashboard'
  //       })
  //     } else {
  //       next({
  //         name: 'Recepcion'
  //       })
  //     }
  //   } else {
  //     let prm = to.meta.prm || "ND";
  //     if (prm == "ND") {
  //       next();
  //     } else {
  //       if ((new Vue).$utilFront.withPermission(prm)) {
  //         next();
  //       } else {
  //         next({
  //           name: 'sinPermiso'
  //         });
  //       }
  //     }
  //   }
  // } else {
  //   next();
  // }

})

export default router